export default {
  LOGIN: 'login', // 로그인
  LOGOUT: 'logout', // 로그인
  WRITE: 'write', //게시글 쓰기
  FETCH_USER_INFO: 'fetchUserInfo', // 게정 정보 가져 오기
  UPDATE_USER_INFO: 'updateUserInfo', // 장 비 정보 수정
  SET_ACCESS_TOEKN: 'setAccessToken',
  FETCH_DEVICES: 'fetchDevices',
  FETCH_DEVICE_ONE: 'fetchDeviceOne',
  ADD_DEVICE: 'addDevice', // 장비 추가 추가
  UPDATE_DEVICE: 'updateDevice', // 장비 정보 수정
  FIND_PASSWORD: 'findPassword', // 비밀번호 찾기
  UPDATE_PHOTO: 'updatePhoto', // 사진 수정
  DELETE_CONTACT: 'deleteContact', // 연락처 삭제
  CHANGE_IS_LOADING: 'changeIsLoading',
  INITIALIZE_CONTACT_ONE: 'initializeContactOne',
  INITIALIZE_DEVICE_ONE: 'initializeDeviceOne',
  SAVE_USER_SELECTION: 'saveUserSelection',
  RESTORE_USR_SELECTION: 'loadUserSelection',
  UPDATE_MENU_RANKING: 'updateMenuRanking', // 메뉴랭킹을 업데이트 한다.
  FETCH_MENUS: 'fetchMenus',
  MAIN_STATE: 'mainState', //메인 메뉴의 상태 정보이다.
  BOARD_DETAIL: "boardDetail",

  COLOR_TABLE: ['#fa5249','#6dce56','#efbc2e','#65b4ea','#f47ac0','#ad69e2','#69e2ae','#f98348','#cc9558','#4a60bc','#8f77aa','#5b5b5b']
}



// WEBPACK FOOTER //
// ./src/constant.js